<div class="d-flex align-self-start w-100 small mb-3 fw-bold totalsRow">
  <div class="column-wrapper">
    <!-- earning totals -->
    <div class="payline-column">
      <div class="row">
        <div class="col-3">
          <h4 class="fw-bold">Totals</h4>
        </div>
        <div class="col-6">
          <div class="d-flex justify-content-between">
            <div>Hrs/Gross</div>
            <div>
              {{ payline.EarningsTotalCurrentHours | number: '1.2-2' }}
            </div>
          </div>
        </div>
        <div class="col-3">
          {{ payline.EarningsTotalCurrentAmount | currency }}
        </div>
      </div>
    </div>
    <!-- tax totals -->
    <div class="payline-column">
      <div class="d-flex justify-content-between">
        <div>Payee Taxes</div>
        <div>{{ payline.TaxesTotalCurrentAmount | currency }}</div>
      </div>
    </div>
    <!-- deduction totals -->
    <div [ngClass]="{ 'payline-column--large': showHoldPaymentColumn }" class="payline-column">
      <div class="d-flex justify-content-between">
        <div>Payee Deds</div>
        <div>{{ payline.DeductionsTotalAmount | currency }}</div>
      </div>
    </div>
    <!-- deposit totals -->
    <div *ngIf="!hideDeposits" class="payline-column">
      <div class="d-flex justify-content-end">
        <div class="row">
          <ng-container *ngIf="payline.NetAmountPaid && payline.NetAmountPaid != 0">
            <div class="col-6 text-end">Net</div>
            <div class="col-6 text-end">
              {{ payline.NetAmountPaid | currency }}
            </div>
          </ng-container>
          <ng-container *ngIf="payline.NetAmountDeposited && payline.NetAmountDeposited != 0">
            <div class="col-6 text-end">Deposited</div>
            <div class="col-6 text-end">
              {{ payline.NetAmountDeposited | currency }}
            </div>
          </ng-container>
          <ng-container
            *ngIf="
              payline.NetCheckAmountPaid &&
              payline.NetCheckAmountPaid != 0 &&
              payline.PaylineType !== paylineType.Manual
            ">
            <div class="col-6 text-end">Check</div>
            <div class="col-6 text-end">
              {{ payline.NetCheckAmountPaid | currency }}
            </div>
          </ng-container>
        </div>
      </div>
    </div>
  </div>
</div>
<!--
  if the deposits column is hidden (for manual payroll)
  show just the Net amount on a new line with right justified text.
  this keeps the totals at the bottom lined up with the columns above.
-->
<div
  [ngClass]="hideDeposits && payline.NetAmountPaid && payline.NetAmountPaid != 0 ? '' : 'invisible'"
  class="text-end">
  <strong>Net {{ payline.NetAmountPaid | currency }}</strong>
</div>
